import { IEditZonePayload, IGetZoneList, IZoneCreate, IZoneDetails, IZoneListSearch } from "../../../types/master/zoneInterface";
import { ZoneActionTypes, ZoneActions } from "../../actionTypes/master/zoneActionTypes";



export const createZone = (payload: IZoneCreate): ZoneActionTypes => ({
  type: ZoneActions.CREATE_ZONE,
  payload,
});

export const getZoneList = (payload: IZoneListSearch): ZoneActionTypes => ({
  type: ZoneActions.GET_ZONE_LIST,
  payload,
});

export const setZoneList = (zoneList: Array<IGetZoneList>) : ZoneActionTypes => ({
  type: ZoneActions.SET_ZONE_LIST,
  payload: zoneList
})

export const setZoneListPageCount = (payload:number): ZoneActionTypes => ({
  type: ZoneActions.SET_ZONE_LIST_PAGE_COUNT,
  payload
})

export const getZoneDataById = (id: number): ZoneActionTypes => ({
  type: ZoneActions.GET_ZONE_DATA_BY_ID,
  payload: id
})

export const setZoneDataById = (payload: IZoneDetails) => ({
  type: ZoneActions.SET_ZONE_DATA_BY_ID,
  payload
})

export const editZone = (payload: IEditZonePayload) => ({
  type: ZoneActions.EDIT_ZONE_DATA_BY_ID,
  payload,
});

export const deleteZone = (id: number): ZoneActionTypes => ({
  type: ZoneActions.DELETE_ZONE,
  payload: id,
});
